import * as Sentry from '@sentry/nextjs';

// Browser error reporting to GlitchTip (Sentry protocol). The DSN is public and baked in
// at build time (Dockerfile ARG NEXT_PUBLIC_SENTRY_DSN); without it nothing is sent.
const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (dsn) {
    Sentry.init({
        dsn,
        environment: process.env.NODE_ENV,
        tracesSampleRate: 0,
        // Third-party ad scripts and browser quirks we cannot act on.
        denyUrls: [/pagead\//, /googlesyndication\.com/, /googletagmanager\.com/],
        ignoreErrors: [/adsbygoogle\.push\(\) error/, /isWellFormed is not a function/, /Non-Error promise rejection captured/],
        // GlitchTip does not implement the sessions protocol: the BrowserSession integration
        // would post a rejected envelope on every page load.
        integrations: (defaults) => defaults.filter((integration) => integration.name !== 'BrowserSession'),
    });
}
